import React, { forwardRef } from 'react';
import Spinner from './Spinner';

function ButtonIcon({ position, children }) {
  return (
    <div className={`absolute right-0 ${position === 'left' ? 'left-0' : 'right-0'}`}>
      {children}
    </div>
  );
}

const Button = forwardRef(
  (
    {
      full,
      size,
      danger,
      primary,
      outline,
      loading,
      children,
      dropdown,
      dropdownWithSelections,
      className,
      innerClassName,
      icon: IconComponent,
      textSize = 'xs',
      iconPos = 'left',
      disabled = false,
      ...rest
    },
    ref
  ) => {
    let classes = `font-semibold rounded block text-2xs lg:text-${textSize} focus:outline-none`;
    let inverted = false;

    if (full) {
      classes += ' w-full';
    }

    if (size === 'extra-large') {
      classes += ' px-4 py-2 h-16';
    } else if (size === 'large') {
      classes += ' px-4 h-10';
    } else if (size === 'medium') {
      classes += ' px-2/2 h-8';
    } else if (size === 'small') {
      classes += ' px-2/2 h-6';
    } else {
      classes += ' px-1 md:px-2 lg:px-4 h-6 lg:h-8';
    }

    if (disabled && primary) {
      classes += ' bg-opacity-50 bg-primary-400 text-white cursor-not-allowed';
    } else if (primary) {
      classes +=
        ' bg-primary-400 text-white border border-primary-400 hover:bg-blue-600 hover:border-blue-600';
    } else if (danger && outline) {
      classes += ' border border-red-400 text-red-400 hover:bg-red-400 hover:text-white';
    } else if (disabled && danger) {
      classes +=
        ' bg-opacity-50 bg-red-400 text-white border border-red-700 cursor-not-allowed';
    } else if (danger) {
      classes +=
        ' bg-red-400 text-white border border-red-400 hover:bg-red-500 hover:border-red-500';
    } else if (disabled && outline) {
      classes +=
        ' border border-primary-400 text-primary-400 opacity-50 primary-outlined-disabled cursor-not-allowed';
    } else if (outline) {
      classes +=
        ' border border-primary-400 text-primary-400 hover:bg-primary-400 hover:text-white primary-outlined';
    } else if (disabled && dropdown) {
      inverted = true;
      classes += ' border border-gray-600 text-gray-600 bg-opacity-75 cursor-not-allowed';
    } else if (dropdown) {
      inverted = true;
      classes +=
        ' border border-gray-600 text-gray-600 hover:border-gray-700 hover:text-white hover:bg-gray-700';
    } else if (dropdownWithSelections) {
      inverted = true;
      classes +=
        ' border border-primary-400 text-primary-400 hover:border-gray-700 hover:text-white hover:bg-gray-700';
    } else if (disabled) {
      classes +=
        ' bg-opacity-75 bg-white text-black border border-black cursor-not-allowed';
    } else {
      inverted = true;
      classes +=
        ' bg-white text-black border border-black hover:bg-black hover:text-white';
    }

    return (
      <button
        className={`${classes} ${className || ''} stroke-current fill-current`}
        disabled={loading || disabled}
        ref={ref}
        {...rest}
      >
        <div
          className={`flex items-center justify-between space-x-2 relative ${innerClassName}`}
        >
          {IconComponent && (
            <ButtonIcon position={iconPos}>
              <IconComponent />
            </ButtonIcon>
          )}
          <span className="leading-3 w-full">{children}</span>
          {loading && <Spinner inverted={inverted} />}
        </div>
      </button>
    );
  }
);

export default Button;
